import { Box } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PlayFillIcon } from 'Asset/icon';
import { TextMedium, TextSemiBold } from 'UiKit/typography';
import useGetPresences from 'Domain/host-attendance-record/useGetPresences';

import styles from './styles.module.css';
import { useUserInfo } from 'Store/userInfo';

const LivestreamFloating = ({ isHideNavBar }) => {
  const { t } = useTranslation('host-stream');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { organization } = useUserInfo();
  const isMalayOrg = organization?.region === 'MY';
  const isScheduleDetailPage = pathname.startsWith('/host/detail');

  const { data: presenceData } = useGetPresences();
  const { streamingSessions } = presenceData ?? {};

  const streamTitle = `Livestream ${streamingSessions?.length}`;

  const bottomMargin = isHideNavBar || isScheduleDetailPage ? '38px' : '70px';
  const right = isMalayOrg ? '16px' : 'max(78px, calc(50% - 210px))';
  return (
    <Box className={styles['livestream-floating__container']} bottom={bottomMargin} onClick={() => navigate('/host/stream')} right={right}>
      <PlayFillIcon size="24" color="var(--color-success60)" />
      <Box className={styles['livestream-floating__text-container']}>
        <TextSemiBold fontSize="var(--font-body3)">{streamTitle}</TextSemiBold>
        <TextMedium fontSize="var(--font-caption1)">{t('floating_livestream.livestream_ongoing')}</TextMedium>
      </Box>
    </Box>
  );
};

export default LivestreamFloating;
